"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CashierExpressCheckoutWidget = void 0;
var WidgetLazyComponent_public_1 = require("./WidgetLazyComponent.public");
Object.defineProperty(exports, "CashierExpressCheckoutWidget", { enumerable: true, get: function () { return WidgetLazyComponent_public_1.WidgetLazyComponentPublic; } });
//# sourceMappingURL=index.js.map